export enum PatientAssignmentStatus {
    ASSIGNED = 0,
    UNASSIGNED = 1,
    ASSIGNED_AND_UNASSIGNED = 2,
}
